module.exports = __webpack_public_path__ + "res/12-img_game_top_1.a43c12458129ea93eaaef3f2fabf1161.png";